import React from "react";
import { Stack, Text } from "@fluentui/react";

const Footer: React.FC = () => {
  return (
    <Stack
      horizontalAlign="center"
      styles={{ root: { padding: "10px", backgroundColor: "#f3f2f1" } }}
    >
      <Text variant="small">© 2025 Delta Flame. All rights reserved.</Text>
    </Stack>
  );
};

export default Footer;
